import { init } from "@sentry/react";

export const initializeSentry = (environment: string) => {
  init({
    dsn: "https://e9cc13fb4bcd4bd9b55f06a7898f7159@o160250.ingest.sentry.io/6707190",
    attachStacktrace: true,
    environment,
  });
};
